import { Button } from "@mui/material";
import { buttonMainStyle } from "./Styles";

const ButtonMain = ({ onClick, children, ...props }) => (
  <Button
    variant="contained"
    sx={buttonMainStyle}
    onClick={onClick}
    {...props}
  >
    {children}
  </Button>
);

export default ButtonMain;